import { chainedDataIndexExtractor } from "./chainedDataIndex";
export let SortOrder;

(function (SortOrder) {
  SortOrder["ASC"] = "asc";
  SortOrder["DESC"] = "desc";
})(SortOrder || (SortOrder = {}));

export const sortData = (sort, data) => {
  return sort.order && sort.orderBy ? [...data].sort((a, b) => {
    const orderBy = sort.orderBy || "";
    const r = chainedDataIndexExtractor(orderBy, a) < chainedDataIndexExtractor(orderBy, b) ? -1 : chainedDataIndexExtractor(orderBy, a) > chainedDataIndexExtractor(orderBy, b) ? 1 : 0;
    return sort.order === SortOrder.ASC ? r : r * -1;
  }) : [...data];
};
export let FilterType;

(function (FilterType) {
  FilterType["LIKE"] = "like";
  FilterType["GREATER_THAN"] = "gt";
  FilterType["GREATER_THAN_EQUAL"] = "gte";
  FilterType["LESS_THAN"] = "lt";
  FilterType["LESS_THAN_EQUAL"] = "lte";
  FilterType["MULTIPLE"] = "multiple";
  FilterType["MULTIPLE_EXCLUSION"] = "multiple_exclusion";
  FilterType["DROPDOWN"] = "dropdown";
  FilterType["BOOLEAN"] = "bool";
  FilterType["INTEGER"] = "integer";
  FilterType["DECIMAL"] = "decimal";
  FilterType["DATE"] = "date";
  FilterType["MANUAL"] = "manual";
  FilterType["PARAMETER"] = "parameter";
})(FilterType || (FilterType = {}));

const filterCondition = (type, filterValue, value) => {
  let status = false;

  switch (type) {
    case FilterType.MULTIPLE:
      status = filterValue.includes(value);
      break;

    case FilterType.LESS_THAN:
      status = value < filterValue;
      break;

    case FilterType.LESS_THAN_EQUAL:
      status = value <= filterValue;
      break;

    case FilterType.GREATER_THAN:
      status = value > filterValue;
      break;

    case FilterType.GREATER_THAN_EQUAL:
      status = value >= filterValue;
      break;

    default:
      status = new RegExp(`${filterValue}`.replace( // eslint-disable-next-line no-useless-escape
      /[\^\$\.\+\*\(\)\?\!\[\]]/g, a => `\\${a}`), "i").test(`${value}`);
      break;
  }

  return status;
};

export const filterData = (filters, data, dataIndexExtension = '') => {
  return filters.length ? [...data].filter(row => {
    return filters.every(filter => {
      if (Array.isArray(filter.dataIndex)) {
        return filter.dataIndex.some(dataIndex => {
          return filterCondition(filter.type, filter.value, chainedDataIndexExtractor(`${dataIndex}${dataIndexExtension}`, row));
        });
      } else {
        return filterCondition(filter.type, filter.value, chainedDataIndexExtractor(`${filter.dataIndex}${dataIndexExtension}`, row));
      }
    });
  }) : [...data];
};
export const groupData = (dataIndex, data) => {
  return data.reduce((result, item) => {
    const value = chainedDataIndexExtractor(dataIndex, item);

    if (value in result) {
      result[value].push(item);
    } else {
      result[value] = [item];
    }

    return result;
  }, {});
};
export const shuffleData = data => {
  return data.sort(() => Math.random() - 0.5);
};
export const uniqueData = (dataIndex, data) => {
  return data.reduce((result, item) => {
    const value = chainedDataIndexExtractor(dataIndex, item);

    if (!result.some(each => chainedDataIndexExtractor(dataIndex, each) === value)) {
      result.push(item);
    }

    return result;
  }, []);
};
export const excludeDuplicate = data => {
  return data.reduce((result, item) => {
    if (!result.includes(item)) {
      result.push(item);
    }

    return result;
  }, []);
};
export const uniqueDataString = data => {
  return excludeDuplicate(data);
};
export const objectByIndex = (field, data) => {
  return data.reduce((result, item) => {
    result[chainedDataIndexExtractor(field, item)] = item;
    return result;
  }, {});
};
export const pickRecord = (record, picks) => {
  return Object.keys(record).filter(key => picks.includes(key)).reduce((result, key) => {
    result[key] = record[key];
    return result;
  }, {});
};
export const omitRecord = (record, picks) => {
  return Object.keys(record).filter(key => !picks.includes(key)).reduce((result, key) => {
    result[key] = record[key];
    return result;
  }, {});
};